import React, { useEffect, useState } from "react";

const COLOR_MAP = {
  blue: "bg-blue-500",
  amber: "bg-amber-400",
  violet: "bg-violet-500",
  emerald: "bg-emerald-500",
  rose: "bg-rose-500",
  cyan: "bg-cyan-500",
};

const Sequence = ({ game, level, lang, onFinish }) => {
  const lvl = game.levels[level - 1] || {};
  const colors = lvl.colors || game.data.colors;
  const maxRound = lvl.maxRound || game.data.maxRound;
  const showMs = Math.max(220, 700 - (level - 1) * 80);
  const pointsPerLevel = lvl.points || game.points;

  const [round, setRound] = useState(1);
  const [seq, setSeq] = useState([]);
  const [showing, setShowing] = useState(false);
  const [activeIdx, setActiveIdx] = useState(-1);
  const [userPos, setUserPos] = useState(0);

  const nextRound = (currentSeq) => {
    const ns = [...currentSeq, Math.floor(Math.random() * colors.length)];
    setSeq(ns);
    setUserPos(0);
    setShowing(true);
  };

  useEffect(() => {
    if (round === 1 && seq.length === 0) nextRound([]);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!showing) return;
    let i = 0;
    const interval = setInterval(() => {
      setActiveIdx(seq[i]);
      setTimeout(() => setActiveIdx(-1), showMs / 2);
      i++;
      if (i >= seq.length) {
        clearInterval(interval);
        setTimeout(() => setShowing(false), showMs);
      }
    }, showMs);
    return () => clearInterval(interval);
  }, [showing, seq, showMs]);

  const press = (idx) => {
    if (showing) return;
    if (seq[userPos] === idx) {
      const newPos = userPos + 1;
      setUserPos(newPos);
      if (newPos === seq.length) {
        if (round >= maxRound) {
          const earned = Math.round((round / maxRound) * pointsPerLevel);
          onFinish({ score: round, points: earned, total: maxRound });
        } else {
          setRound(round + 1);
          setTimeout(() => nextRound(seq), 500);
        }
      }
    } else {
      const earned = Math.round(((round - 1) / maxRound) * pointsPerLevel);
      onFinish({ score: round - 1, points: earned, total: maxRound });
    }
  };

  return (
    <div data-testid={`game-sequence-${game.id}`}>
      <div className="flex justify-between text-sm mb-3">
        <span className="bs-amber font-bold">
          {lang === "es" ? "Ronda" : "Round"}: {round}/{maxRound}
        </span>
        <span className="bs-muted">
          {showing
            ? lang === "es"
              ? "Mira…"
              : "Watch…"
            : lang === "es"
            ? "Ahora tú"
            : "Now you"}
        </span>
      </div>
      <div className={`grid ${colors.length > 4 ? "grid-cols-3" : "grid-cols-2"} gap-3 max-w-xs mx-auto`}>
        {colors.map((c, idx) => (
          <button
            key={`${c}-${idx}`}
            onClick={() => press(idx)}
            disabled={showing}
            data-testid={`seq-pad-${c}`}
            className={`aspect-square rounded-3xl border-4 border-white/10 transition-all ${
              activeIdx === idx
                ? `${COLOR_MAP[c] || "bg-blue-500"} scale-95 shadow-[0_0_40px_-4px_currentColor]`
                : `${COLOR_MAP[c] || "bg-blue-500"} opacity-50`
            }`}
            aria-label={c}
          />
        ))}
      </div>
    </div>
  );
};

export default Sequence;
